<input type="text" [ngClass]="[inputClass]" value="{{name}}"  placeholder="{{ inputPlaceHolder }}" /> 
